import { prop, required } from "@rxweb/reactive-form-validators";
import { Resource } from "src/app/core/jsonapi/resource";

export class CalendarEvent extends Resource {
    public override type = 'calendarEvents';
    
    @prop()  
    @required()  
    public calendarId!: string;  

    @prop()    
    @required()
    public date!: string;  

    @prop()    
    public description!: string;  
    
}